function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

function checkGridStates() {
	const gridBlocks = document.querySelectorAll(".wp-block-ma-grid");
	gridBlocks.forEach((grid) => {
		const computedStyle = getComputedStyle(grid);
		const paddingTotal =
			parseInt(computedStyle.paddingLeft) +
			parseInt(computedStyle.paddingRight);
		const innerWidth = grid.clientWidth - paddingTotal;
		const itemWidth = grid.children[grid.children.length - 1].offsetWidth;

		if (innerWidth === itemWidth) {
			grid.classList.add("is-single-column");
		} else {
			grid.classList.remove("is-single-column");
		}
	});
}

window.addEventListener("resize", (ev) => {
	checkGridStates();
});

ready(() => {
	checkGridStates();
});
